import * as actionTypes from 'actions';

const initialState = {
  pageNumber: 1,
  rowCount: 0,
  loading: false,
  items: [],
  pageSize: 250,
  filterItemCount: null,
  filter: {
    search: '',
    columnSorts: []
  },
  groups: [],
  groupsLoading: false,
  dataSetType: null,
  tab: 'all',
  selectedDataSetIds: []
};

const PAGE = 'EVENT_DATA_SET_LIST';

const eventDataSetListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.EVENT_DATA_SETS_PAGINATED_LIST_PENDING: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.EVENT_DATA_SETS_PAGINATED_LIST_FULFILLED: {
      return {
        ...state,
        ...action.payload.data.result,
        filter: {
          ...initialState.filter,
          ...action.payload.data.result.filter
        },
        loading: false
      };
    }

    case actionTypes.SET_EVENT_DATA_SET_LIST_TAB: {
      return {
        ...state,
        tab: action.payload
      };
    }

    case actionTypes.SET_EVENT_DATA_SET_LIST_TYPE: {
      return {
        ...state,
        dataSetType: action.payload
      };
    }

    case actionTypes.SET_FILTER_VALUE: {
      let result;
      if (action.payload.pageName === PAGE) {
        result = {
          ...state,
          filter: {
            ...state.filter,
            ...action.payload.value
          }
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.SET_PAGE_SIZE: {
      let result;
      if (action.payload.pageName === PAGE) {
        result = {
          ...state,
          pageSize: action.payload.pageSize
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.CLEAR_FILTER_VALUES: {
      let result;
      if (action.payload.pageName === PAGE) {
        result = {
          ...state,
          filter: {
            ...initialState.filter,
            search: state.filter.search
          },
          filterItemCount: initialState.filterItemCount
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.GET_FILTER_VALUES_FULFILLED: {
      let result;
      if (
        action.payload.data.result &&
        action.payload.data.result.page === PAGE
      ) {
        result = {
          ...state,
          filterItemCount: action.payload.data.result.filter.filterItemCount,
          filter: {
            ...initialState.filter,
            ...action.payload.data.result.filter
          }
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.EVENT_DATA_SET_UPDATED: {
      const dataSet = action.payload.result;
      const index = state.items.map(item => item.id).indexOf(dataSet.id);

      const items = state.items.slice();

      items[index] = dataSet;

      let result;
      if (index > -1) {
        result = {
          ...state,
          items: items
        };
      } else {
        result = state;
      }

      return result;
    }

    case actionTypes.SELECT_DATA_SET_LIST_DATA_SET: {
      const dataSetId = action.payload;
      const dataSetIds = state.selectedDataSetIds.slice();
      const dataSetIdIndex = dataSetIds.indexOf(dataSetId);

      if (dataSetIdIndex !== -1) {
        dataSetIds.splice(dataSetIdIndex, 1);
      } else {
        dataSetIds.push(dataSetId);
      }

      return {
        ...state,
        selectedDataSetIds: dataSetIds
      };
    }

    case actionTypes.CLEAR_EVENT_DATA_SET_LIST_SELECTED_EVENT_DATA_SETS: {
      return {
        ...state,
        selectedDataSetIds: initialState.selectedDataSetIds
      };
    }

    default: {
      return state;
    }
  }
};

export default eventDataSetListReducer;
